import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <CircularProgress
        size={40}
        sx={{
          color: "#3160d4",
        }}
      />
    </div>
  );
};

export default Loading;
